import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  dateSelection: null,
  empresa: null,
  centroCusto: [],
  produto: [],
  projeto: [],
  responsavel: [],
  grupo: [],
  fornecedor: [],
  solicitante: [],
  filterBySaving: null,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
